module.exports = __webpack_public_path__ + "static/img/visitor-ai.d24353b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/visitor-ai.png
// module id = 9OWu
// module chunks = 9